import { forwardRef, memo } from 'react';

import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverContentProps,
  PopoverProps,
  PopoverTrigger,
  PopoverTriggerProps,
} from '../Popover';
import { cn } from '../../lib/styles';

export interface MenuProps extends PopoverProps {
  children: React.ReactNode;
}

export const MenuTrigger = (props: PopoverTriggerProps) => {
  return <PopoverTrigger {...props} />;
};

export const MenuClose = ({ children }: { children: React.ReactNode }) => {
  return <PopoverClose asChild>{children}</PopoverClose>;
};

export const MenuContent = forwardRef(
  ({ className, children, ...rest }: PopoverContentProps, ref: React.Ref<HTMLDivElement>) => {
    return (
      <PopoverContent ref={ref} className={cn('p-1.5 z-301', className)} {...rest}>
        {children}
      </PopoverContent>
    );
  },
);

export const MenuLabel = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className={cn('font-body-md text-text-tertiary truncate font-semibold my-1.5 px-2', className)}>
      {children}
    </div>
  );
};

const MenuBase = (props: MenuProps) => {
  return <Popover {...props} />;
};

export const Menu = memo(MenuBase);
